<template lang="pug">
.uiInputComponent
  input.input(
    type="file"
    @input="onInput"
    ref="inputRef"
    multiple
  )

  ui-button.button(
    v-bind="$attrs"
    @click="onButtonClick"
  ) {{ buttonText }}

  .error(
    v-for="error in v$.$errors"
    :key="error.$validator"
  ) {{ errors[error.$validator] }}

  .files(v-if="files.length")
    .file(
      v-for="(file, index) in files"
      :key="index"
      :class="{ _error: sizeError(file) }"
    )
      .text {{ !sizeError(file) ? file.name : errors.fileSize }}
      .remove(@click="onRemoveClick(index)")
        ui-svg-icon(name="close")
</template>

<script>
import { ref, computed } from 'vue'
import pluralize from '@/_core/helpers/pluralize'
import { megabitToByte } from '@/_core/helpers/converters'

export default {
  props: {
    v$: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    },
    maxSize: {
      type: Number,
      default: 4
    }
  },
  emits: ['update'],
  setup (props, { emit }) {
    const inputRef = ref(null)
    const files = ref([])
    const buttonText = computed(() => {
      if (files.value.length) {
        return `${pluralize(files.value.length, 'Выбран', 'Выбрано', 'Выбрано')}
          ${files.value.length}
          ${pluralize(files.value.length, 'файл', 'файла', 'файлов')}`
      } else {
        return 'Выбрать файл'
      }
    })
    const onButtonClick = () => {
      inputRef.value.click()
    }
    const onInput = e => {
      files.value.push(...e.target.files)
      update()
    }
    const onRemoveClick = index => {
      files.value.splice(index, 1)
      update()
    }
    const sizeError = file => {
      return file.size > megabitToByte(props.maxSize)
    }
    const update = () => {
      emit('update', files.value)
    }

    return {
      inputRef,
      files,
      buttonText,
      sizeError,
      onInput,
      onButtonClick,
      onRemoveClick
    }
  }
}
</script>

<style lang="sass" scoped>
.uiInputComponent
  .input
    opacity: 0
    visibility: hidden
    position: absolute
    pointer-events: none
    z-index: -1
  .files
    display: flex
    flex-direction: column
    align-items: flex-start
    margin-top: 2*$u
  .file
    margin-top: 2*$u
    background: $cElements
    padding: 2*$u 3*$u
    border-radius: 2*$u
    display: flex
    align-items: center
    .text
      @include font('t14-regular')
    .remove
      margin-left: 2*$u
      width: 14px
      color: $cBlack
      opacity: 0.5
      cursor: pointer
    &._error
      background: $cHtOrange
      color: $cDarkOrange

  .error
    @include font('t14-regular')
    color: $cOrange
    margin-top: 2*$u
</style>
